module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid1.caa03841.png";